__turbopack_context__.v({
  "SWatchlistButton": "decgGq_SWatchlistButton",
  "SWatchlistSvg": "decgGq_SWatchlistSvg",
});
